import { useQuery } from "@tanstack/react-query";
import { Entry } from "../../entry/models/Entry";
import { getEntriesReport } from "../repository/LogbookRepository";

type UseEntriesReportProps = {
	startShiftId: number | null;
	endShiftId: number | null;
	assetId: number | null;
	sectionIds?: number[];
};

export const useEntriesReport = ({
	startShiftId,
	endShiftId,
	assetId,
	sectionIds,
}: UseEntriesReportProps) => {
	return useQuery<Entry[], Error>({
		queryKey: ["entriesReport", startShiftId, endShiftId, assetId, sectionIds],
		queryFn: ({ signal }) =>
			getEntriesReport(
				{
					startShiftId,
					endShiftId,
					assetId,
					sectionIds,
				},
				signal,
			),
	});
};

export const routeLogbookReport = "/logbook/report";
